export default "__VITE_ASSET__mjnSaHyk__"